<template>
    <div class="particulars-wrap" :class="[!relationClassifyValue.length?'wrap-no-right':'']">
        <div class="left col-md-8 col-sm-12 pr-md-0">
            <video-article v-if="routerType==='video' && isRefresh"></video-article>
            <pdf-article v-else-if="routerType==='magazine' && isRefresh"></pdf-article>
            <articles v-else-if="isRefresh"></articles>
        </div>
        <div class="right col-md-4 col-sm-12" v-if="relationClassifyValue.length">
            <!--            <div class="right-top">-->
            <!--                <div class="common-head">-->
            <!--                    <div class="common-line"></div>-->
            <!--                    <div class="common-title">知识图谱</div>-->
            <!--                </div>-->
            <!--                &lt;!&ndash;        <normal-graph :value="graphValue" @changeGraph="gotoChange" ref="graph"></normal-graph>&ndash;&gt;-->
            <!--            </div>-->
            <div class="right-bottom right-bottom-no-graph"
            >
                <div class="right-bottom-head">
                    <classify-tabs :value="relationClassifyValue"
                                   ref="classifyTabs"
                                   @changeTab="(tab,value,index)=>changeRelationValue(index)"></classify-tabs>
                    <el-select v-model="timeType" size="mini" @change="createRecommend(true)" class="time-select">
                        <el-option v-for="item in timeOption" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <relation-list :value="relationValue"
                               class="list-wrap"
                               @change="gotoRelation"></relation-list>
            </div>
        </div>
    </div>
</template>

<script>
import Articles from '@/views/silkRoadBase/components/ArticleDetails/Article.vue'
import VideoArticle from '@/views/silkRoadBase/components/ArticleDetails/videoArticle'
import PdfArticle from '@/views/search/components/PdfArticle'
// import NormalGraph from '../../topics/patentTopics/components/normalGraph'
// import config from '@/common/config'
import MixinUpdateData from '@/views/TheHome/mixins/updateData'
import RelationList from './components/relationList'
import MixinTime from '@/views/TheHome/mixins/dateTime'
import ClassifyTabs from '../components/classifyTabs'
import * as _ from 'lodash'
import searchMap from '../utils/searchMap'
import {baseUrl, simplekw} from 'common/js/http/pdBase'
import MixinsHandleGraph from '@/views/TheHome/mixins/handleGraph'

function tabArr () {
  return [
    {
      label: 'Keyword Recommendation',
      value: 'key'
    },
    {
      label: 'Countries Recommendation',
      value: 'country'
    }
  ]
}

export default {
  name: 'particulars',
  components: {
    ClassifyTabs,
    RelationList,
    VideoArticle,
    PdfArticle,
    // NormalGraph,
    Articles
  },
  mixins: [MixinUpdateData, MixinTime, MixinsHandleGraph],
  data () {
    return {
      isShowBack: true,
      // echarts: ['Graph'],
      clickToggle: true,
      graphValue: {
        graph: null,
        layout: 'none',
        haveNoPage: true
      },
      relationClassifyValue: tabArr(),
      isShowBack: true,
      kwValue: [],
      countryArrValue: [],
      kwArrValue: [],
      relationValue: {
        title: '相关推荐',
        content: []
      },
      QRUrl: '',
      isRefresh: true,
      timeOption: [
        {
          label: 'Mixed',
          value: '混合排序'
        },
        {
          label: 'published',
          value: '时间倒序'
        },
        {
          label: 'Relevancy',
          value: '相关度'
        }
      ],
      timeType: '相关度'
    }
  },
  watch: {
    '$route.params': {
      handler () {
        this.isRefresh = false
        setTimeout(() => {
          this.isRefresh = true
          // this.updateEcharts()
        })
      },
      immediate: true,
      deep: true
    },
    '$route.query': {
      handler () {
        this.$nextTick(() => {
          this.$refs.classifyTabs && (this.$refs.classifyTabs.activeName = '0')
        })
        this.createRecommend()
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    routerType () {
      return this.$route.params.typeId
    },
    subType () {
      return this.$route.params.subType
    }
  },
  beforeCreate () {
    let url = window.location.href
    if (url.indexOf('%2525') === -1 && url.indexOf('%25') !== -1) {
      url = url.replace(/%25/g, '%2525')
      window.location.replace(url)
    }
  },
  mounted () {
    this.createQRUrl()
  },
  methods: {
    createQRUrl () {
      let url = window.location.href
      const kw = url.indexOf('kw=')
      kw && (url = url.substring(0, kw))
      const title = url.lastIndexOf('/')
      title && (url = url.substring(0, title) + '/x')
      url = url.replace(/\/searchType([\s\S]*?)\/searchDetail/, '/searchType/all/1//searchDetail')
      let arr = url.split('/')
      arr = arr.map((item) => {
        if (item.indexOf('%') === -1) {
          return item
        } else {
          return ''
        }
      })
      this.QRUrl = arr.join('/')
    },
    gotoChange () { // 跳转到国家专题
      this.$router.push({name: 'nationalCityTopics'})
    },
    gotoRelation (val) { // 相关推荐的跳转
      // debugger
      let url = this.$route.path
      const index = url.indexOf('searchDetail')
      url = url.slice(0, index - 1)
      this.gotoSearchDetail(val.message, url)
      // const path = this.gotoDetail(val.message, url, encodeURIComponent(val.title) || '')
      // this.$router.push({path})
    },
    gotoDetail (val, url, kgId) { // 进入详情
      let id = _.split(val.sourceAsMap.contentid, '_')[1]
      const typeItem = _.find(searchMap.typeAgg, ['value', val.sourceAsMap.column])
      let type = (val.sourceAsMap && val.sourceAsMap.modelType) || (typeItem && typeItem.id) || val.type
      let secondPath = ''
      if (!val.sourceAsMap.contentid) { // 研报
        id = val.sourceAsMap.eid
        type = '研报'
        secondPath = '/' + val.sourceAsMap.type
      }
      let firstPath = url + 'searchDetail/' + id + '/' + type + '/' + kgId
      let query = ''
      if (val.sourceAsMap) {
        // 配置kw传参
        if (val.sourceAsMap['tags']) {
          query = `${query}kw=${val.sourceAsMap['tags'].toString()}`
        }
        if (val.sourceAsMap['one_level_state']) {
          query = `${query}&country=${val.sourceAsMap['one_level_state'].toString()}`
        }
      }
      return firstPath + secondPath + '?' + query
    },
    clickToggles () {
      this.clickToggle = false
    },
    goback () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    // requestGraph () {
    //   const data = {
    //     id: this.$route.params.kgId
    //   }
    //   this.$pdAxios({
    //     method: 'post',
    //     url: '/search/graphExplore',
    //     data,
    //     baseURL: config.baseUrl
    //   })
    //     .then((data) => {
    //       if (data.data.errCode === 200) {
    //         this.graphValue.graph = data.data.data
    //         setTimeout(() => {
    //           if (this.$refs.graph && this.$refs.graph.graph) {
    //             this.$refs.graph.graph.netChart.fitPanel()
    //           }
    //         })
    //       }
    //     })
    // },
    changeRelationValue (index) {
      this.relationValue.content = ~~index ? this.countryArrValue : this.kwArrValue || []
    },
    /**
     * 创建搜索对象
     * @param kw 关键词
     * @param filters 国家
     * @returns {{current: number, featureWeights: [], isExplain: boolean, hieghtQueryBean: [], pageNo: number, pageSize: number, docTypeList: [string], filters: (*|[{d: string, v: [], k: string}]), kw: string, templateId: string, isAggs: number}}
     */
    createSearchData (kwArr = []) {
      let data = {
        docTypeList: ['All'],
        kw: kwArr.join(' '),
        featureWeights: [],
        filters: [],
        hieghtQueryBean: [],
        isExplain: false,
        pageNo: 1,
        pageSize: 10,
        templateId: '',
        current: 0,
        isAggs: 1,
        psn: 10005
      }
      switch (this.timeType) {
        case '相关度':
          data.isRelevancy = true
          break
        case '时间倒序':
          data.sortField = 'published'
          data.sorts = '1'
          break
        case '混合排序':
          data.featureWeights = [
            {'k': '16', 'v': '2'},
            {'k': '19', 'v': '1'},
            {'k': '18', 'v': '1.3'},
            {'k': '17', 'v': '1.5'},
            {'k': '20', 'v': '2'}
          ]
          data.templateId = '3'
          break
      }
      return data
    },
    /**
     * 创建推荐列表逻辑
     */
    createRecommend (type) {
      let activeName = ''
      if (type) {
        activeName = this.$refs.classifyTabs.activeName
      }
      this.relationClassifyValue = tabArr()
      let {kw, country} = this.$route.query
      let isKw = false
      if (kw) {
        isKw = true
        kw = kw.split(',')
        this.getKwRecommend(kw)
          .then((data) => {
            console.log(!type || (activeName === '0'))
            if (!type || (activeName === '0')) {
              this.changeRelationValue('0')
            }
          })
      } else {
        let index = _.findIndex(this.relationClassifyValue, ['label', 'Keyword Recommendation'])
        this.relationClassifyValue.splice(index, 1)
      }
      if (country) {
        country = country.split(',')
        this.getCountryRecommend(country)
          .then((data) => {
            console.log(!type || activeName === '1' || !isKw)
            if ((!type && !isKw) || activeName === '1') {
              this.changeRelationValue('1')
            }
          })
      } else {
        let index = _.findIndex(this.relationClassifyValue, ['label', 'Countries Recommendation'])
        this.relationClassifyValue.splice(index, 1)
      }
    },
    /**
     * 创建关键词推荐数据
     * @param kw
     */
    getKwRecommend (kw) {
      if (kw) {
        const data = this.createSearchData(kw)
        return simplekw(data)
          .then((data) => {
            if (data.errCode === 200) {
              const _data = data.data.rsData
              this.kwArrValue = this.createRecommendContent(_data)
              return Promise.resolve(this.kwArrValue)
            }
            return Promise.reject(new Error())
          })
      }
    },
    /**
     * 获取国家推荐数据
     * @param arr
     */
    getCountryRecommend (arr) {
      if (arr) {
        return this.$pdAxios({
          method: 'post',
          url: '/search/simplekw',
          baseURL: baseUrl,
          data: this.createSearchData(arr)
        })
          .then((data) => {
            if (data.data.errCode === 200) {
              const _data = data.data.data.rsData
              this.countryArrValue = this.createRecommendContent(_data)
              return Promise.resolve(this.countryArrValue)
            }
            return Promise.reject(new Error())
          })
      }
    },
    /**
     * 根据请求回来的数据 处理成表单内容接收的样子
     * @param arr
     * @returns {[]}
     */
    createRecommendContent (arr) {
      const content = []
      for (let _item of arr) {
        const item = _item.sourceAsMap
        item.pulished = item['create_time'] || item.published
        item.pulished = this.timeTampToTime(item.pulished)
        item.type = item.column
        item.message = _item
        content.push(item)
      }
      return content
    }
  }
}
</script>

<style scoped lang="scss">
    @media screen and (min-width: 768px) {
        .particulars-wrap {
            height: calc(100vh - 69px - 18px) !important;
            overflow: hidden;
            margin-bottom: 18px !important;
        }
    }

    @media screen and (max-width: 767px) {
        .particulars-wrap {
            height: calc(100vh - 65px - 71px) !important;
            overflow: auto;
        }

        .right {
            width: calc(100% - 32px) !important;
            padding: 0;
            margin: 16px !important;
        }

        .right-bottom {
            overflow: auto;
        }

        /deep/ .centre_content {
            height: 100% !important;
        }

        /deep/ .article-wrap {
            height: 100% !important;
        }

        .left div {
            height: 100%;
        }
    }

    .left {
        height: calc(100% - 16px);
        width: 100%;
        margin: 16px 0 0 0;

        & > div {
            position: relative;
            width: 100%;
            height: 100%;

            /deep/ > div:nth-child(2) {
                position: relative;
                width: 100%;
                height: 100%;
            }
        }

        .article-wrap {
            height: 100% !important;
        }
    }

    .right {
        width: 100%;
        height: calc(100% - 16px);
        margin: 16px 0 0 0;

        & > div {
            width: 100%;
            height: 100%;
        }

        .right-top {
            height: 36%;
            background: #ffffff;
            padding: 24px;

            .graph-content {
                height: calc(100% - 48px);
                margin-top: 10px;
                cursor: pointer;
                background: #ffffff;
            }
        }

        .right-bottom {
            display: flex;
            flex-direction: column;
            height: calc(100% - 10px);
            width: 100%;
            background: #ffffff;
            margin-top: 10px;
            padding: 12px 24px 24px 24px;

            .right-bottom-head {
                display: flex;
                align-items: center;
                width: 100%;

                .time-select {
                    width: 95px;
                    flex: none;
                }

                /deep/ #classify-tab {
                    flex: auto;
                    margin: 0 10px 0 0;
                    width: calc(100% - 100px);
                }
            }

            /deep/ .el-tabs__item {
                font-weight: bolder !important;
                font-size: 16px !important;
            }

            .list-wrap {
                height: calc(100% - 54px);
            }
        }

    }

    .right-bottom-no-graph {
        margin-top: 0 !important;
        height: 100% !important;
    }

    /deep/ .pdvis-node-legend {
        display: none;
    }

    .iphone-bottom {
        /deep/ .myfix {
            bottom: 60px !important;
        }

        /deep/ .left {
            > div {
                > :nth-child(3) {
                    height: 100%;

                    > div {
                        &:nth-child(1) {
                            height: 100%;
                        }

                    }
                }
            }
        }
    }

    .pc-bottom {

    }

    /deep/ .left {
        > div {
            > :nth-child(3) {
                > div {
                    &:nth-child(1) {
                        > div {
                            position: static !important;
                        }
                    }

                }
            }
        }
    }

    .wrap-no-right {
        .left {
            flex: 100% !important;
            max-width: 100%;
        }
    }

    /deep/ .video_article_video {
        height: 60vh;

        > div {
            width: 100%;
            height: 100%;

            > .video-js {
                width: 100%;
                height: 100%;
            }

            > div {
                width: 100%;
                height: 100%;

                > video {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
